export interface HelpLink {
  id: string;
  label: string;
  href: string;
}

export const HELP_LINKS: HelpLink[] = [
  {
    id: "share-feedback",
    label: "Share Feedback",
    href: "https://survey.fieldsense.whs.amazon.dev/survey/3c6590e4-c6d1-482e-90e0-0d7d13bc4400",
  },
  {
    id: "report-issue",
    label: "Report An Issue",
    href: "https://t.corp.amazon.com/create/templates/618922ea-e1b9-47e7-9284-a9be03b91247",
  },
  {
    id: "feature-request",
    label: "Feature Request",
    href: "https://tiny.amazon.com/181ysgtat/simamazissucrea",
  },
  {
    id: "wiki",
    label: "Wiki",
    href: "https://w.amazon.com/bin/view/WWCF_IPAT/FinTech/CoreEngineering/Teams/FinSpace/Home",
  },
];
